import React, { RefObject, forwardRef } from "react";

import styles from "./blueprint-table.module.scss";
import { BlueprintsArrayObjectTypes } from "@common/types/blueprint-types";
import { BlueprintTableHeader } from "@src/components/molecules/blueprint-table-header/blueprint-table-header";
import { BlueprintTableBody } from "@src/components/molecules/blueprint-table-body/blueprint-table-body";

interface popoverPositionObjectTypes {
  x: number;
  y: number;
}

interface BlueprintTablePropTypes {
  blueprintArray: BlueprintsArrayObjectTypes[];
  activeBlueprint?: BlueprintsArrayObjectTypes;
  popoverPositionCallback?: (coordinates: popoverPositionObjectTypes) => void;
  activeBlueprintCallback: (blueprint: BlueprintsArrayObjectTypes) => void;
  activePopoverCallback?: (blueprint: BlueprintsArrayObjectTypes) => void;
}

const cssClassName = "blueprint-table";

export const BlueprintTable = forwardRef(
  (
    {
      blueprintArray,
      activeBlueprint,
      popoverPositionCallback,
      activeBlueprintCallback,
      activePopoverCallback,
    }: BlueprintTablePropTypes,
    ref: RefObject<HTMLDivElement>,
  ) => {
    return (
      <table className={styles[`${cssClassName}`]}>
        <BlueprintTableHeader />
        <BlueprintTableBody
          ref={ref}
          blueprintArray={blueprintArray}
          activeBlueprint={activeBlueprint}
          popoverPositionCallback={popoverPositionCallback}
          activeBlueprintCallback={activeBlueprintCallback}
          activePopoverCallback={activePopoverCallback}
        />
      </table>
    );
  },
);

BlueprintTable.displayName = "BlueprintTable";
